import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-black text-white border-t-4 border-[#FFD600]" data-testid="footer">
      {/* Big CTA */}
      <div className="bg-[#FFD600] text-black py-16 border-b-4 border-black">
        <div className="container-main text-center">
          <p className="text-sm font-bold uppercase tracking-widest mb-4">Ready to get online?</p>
          <h2 className="text-4xl md:text-6xl font-black mb-6" style={{ fontFamily: "Outfit, sans-serif" }}>
            Your Website. Live in 48 Hours.
          </h2>
          <p className="text-xl font-semibold mb-8 max-w-xl mx-auto">
            Professional. Fast. Affordable. No technical headaches.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/purchase"
              className="bg-black text-white font-bold border-2 border-black px-10 py-4 rounded-full text-lg transition-all hover:-translate-y-1"
              style={{ boxShadow: "4px 4px 0px 0px rgba(0,0,0,0.3)" }}
              data-testid="footer-cta-quote"
            >
              Get My Website — $499
            </Link>
            <a
              href="tel:0466476264"
              className="bg-white text-black font-bold border-2 border-black px-10 py-4 rounded-full text-lg transition-all hover:-translate-y-1"
              style={{ boxShadow: "4px 4px 0px 0px rgba(0,0,0,0.3)" }}
              data-testid="footer-cta-call"
            >
              Call 0466 476 264
            </a>
          </div>
        </div>
      </div>

      {/* Links */}
      <div className="container-main py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="bg-white rounded-xl px-3 py-2 inline-block">
              <img src="/logo.png" alt="No Fuss Websites" className="h-8 w-auto" />
            </div>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed mb-4">
            Professional websites for Aussie businesses. No technical headaches. Just great results.
          </p>
          <div className="flex gap-3">
            {[
              { Icon: Facebook, href: "https://www.facebook.com/nofusswebsite", label: "Facebook" },
              { Icon: Instagram, href: "https://www.instagram.com", label: "Instagram" },
            ].map(({ Icon, href, label }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-9 h-9 bg-white/10 border border-white/20 rounded-lg flex items-center justify-center hover:bg-[#FFD600] hover:text-black hover:border-[#FFD600] transition-colors">
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-black text-[#FFD600] uppercase tracking-wider text-sm mb-4">Services</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            {["Starter Website — $499", "Business Website — $899", "eCommerce Store — $1,499", "SEO Packages", "Website Hosting", "Domain Names"].map(item => (
              <li key={item}><Link to="/packages" className="hover:text-[#FFD600] transition-colors">{item}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-black text-[#FFD600] uppercase tracking-wider text-sm mb-4">Company</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            {[["About Us", "/about"], ["Portfolio", "/portfolio"], ["How It Works", "/how-it-works"], ["Services", "/services"], ["Areas We Serve", "/areas"], ["FAQ", "/faq"], ["Blog", "/blog"], ["Contact", "/contact"]].map(([label, href]) => (
              <li key={href}><Link to={href} className="hover:text-[#FFD600] transition-colors">{label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-black text-[#FFD600] uppercase tracking-wider text-sm mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-gray-400">
            <li className="flex gap-2 items-start">
              <Phone size={14} className="text-[#FFD600] mt-0.5 shrink-0" />
              <a href="tel:0466476264" className="hover:text-[#FFD600] transition-colors font-semibold">0466 476 264</a>
            </li>
            <li className="flex gap-2 items-start">
              <Mail size={14} className="text-[#FFD600] mt-0.5 shrink-0" />
              <a href="mailto:hello@nofusswebsites.com.au" className="hover:text-[#FFD600] transition-colors">hello@nofusswebsites.com.au</a>
            </li>
            <li className="flex gap-2 items-start">
              <MapPin size={14} className="text-[#FFD600] mt-0.5 shrink-0" />
              <span>Melbourne, Victoria, Australia</span>
            </li>
          </ul>
          <div className="mt-6 p-4 border-2 border-[#FFD600]/30 rounded-xl bg-white/5">
            <p className="text-xs text-gray-400 mb-1 font-bold uppercase tracking-wider">Business Hours</p>
            <p className="text-sm text-white">Mon–Fri: 9am – 6pm AEST</p>
            <p className="text-sm text-white">Sat: 10am – 3pm AEST</p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-main py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} No Fuss Websites. All rights reserved. ABN: 57 371 480 477</p>
          <div className="flex gap-6">
            <a href="/privacy-policy" className="hover:text-[#FFD600] transition-colors">Privacy Policy</a>
            <a href="/terms-of-service" className="hover:text-[#FFD600] transition-colors">Terms of Service</a>
            <Link to="/admin/login" className="hover:text-[#FFD600] transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
